'use client';

import { config } from '@/configs/env';

/**
 * Shared session refresh via same-origin API proxy.
 *
 * Deduplicated: concurrent calls share a single in-flight request.
 * This prevents multiple 401 retries or ensureAuth calls from
 * hammering /api/auth/session in parallel.
 */
let _inflight: Promise<boolean> | null = null;

export async function refreshSession(): Promise<boolean> {
  if (_inflight) return _inflight;

  // TODO: need to update
  _inflight = fetch(config.SESSION_API_URL)
    .then((res) =>
      res.ok
        ? res.json().then((d: { status: string }) => d.status === 'ok')
        : false
    )
    .catch(() => false)
    .finally(() => {
      _inflight = null;
    });

  return _inflight;
}
